module.exports = __webpack_public_path__ + "static/insert_mini_calendar_before-fdd271cd30d07f5f82d8c8fe2ede1838.png";